import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { PageSelector } from '.';
import classNames from 'classnames';
import { translate } from '../services';
import { Box, IconButton } from '@mui/material';
import { CloseIconNew } from '../../style/images';
import { ResetButton } from '../site';

export class SelectionViewer extends Component {
  constructor() {
    super();
    this.state = {
      slider: null,
      pages: 1
    };
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  setSlider = div => !this.state.slider && this.mounted && this.setState( { slider: div } )

  onPageUpdate = pages => this.mounted && this.setState( { pages } )

  render() {
    const { children, className } = this.props;
    const { pages, slider } = this.state;

    return <div className={ classNames( 'selection-viewer', className, { 'single-page': pages <= 1 } ) }>
      <Box width="100%" sx={{display:{md:"none", xs:this.props.searchFilter?"none":"flex"}, alignItems:"center", justifyContent:"flex-end", padding:"0px 16px", mt:"40px"}}>
        <IconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.props.onClose} sx={{width:"24px", height:"24px"}}>
          <Box component="img" src={CloseIconNew} sx={{width:"24px", height:"24px"}}></Box>
        </IconButton>
      </Box>
      {this.props.resetHeader&&<div style={{width:"100%", height:"max-content", marginBottom:"16px", padding:"0px 16px"}}><ResetButton currentSelector={this.props.currentSelector} fromMobileFilter={true}></ResetButton></div>}
      <div className="selections">
        <div ref={ this.setSlider } className="slider">  
          { children }
        </div>
      </div>
      { slider && <PageSelector slider={ slider } totalFilterCount={this.props.totalFilterCount} children={ children.length } onPageUpdate={ this.onPageUpdate }/> }
      <div className='filter-footer'>
        {/* <div className='tertiary-button' onClick={ this.props.onClose }>
            <span style={{color: "var(--primary-color-grey-100, #0F0F0F)"}}>{translate("Cancel")}</span>
        </div> */}
        <div className='primary-button' onClick={ this.props.onClose }>
          <span>{ translate( 'See Results' ) }</span>
          </div>
      </div>
    </div>;
  }
}

SelectionViewer.propTypes = {
  children: PropTypes.oneOfType( [PropTypes.arrayOf( PropTypes.node ), PropTypes.node] ),
  className: PropTypes.string
};
